import { GradientGlow } from './gradient-glow'
import { RunePattern3 } from './rune-pattern-3'
import { RunePattern4 } from './rune-pattern-4'

// Layering (front to back): Gradient glows > Rune patterns > Dot grid
export function BackgroundOrnaments() {
  return (
    <div className="isolate absolute -z-50">
      {/* Gradient glow bottom left */}
      <GradientGlow className="z-50 fixed top-4/5 right-0 pointer-events-none" />
      {/* Gradient glow top right */}
      <GradientGlow className="z-50 fixed bottom-4/5 left-1/3 pointer-events-none" />

      {/* Rune patterns mobile */}
      <RunePattern3 className="z-40 md:hidden fixed top-0 left-1/2 -translate-x-1/2 h-screen animate-rune pointer-events-none" />
      {/* Rune patterns desktop */}
      <RunePattern4 className="z-40 hidden md:block fixed top-1/2 left-1/2 -translate-1/2 w-[calc(100vw-140px)] animate-rune pointer-events-none" />

      {/* Dot grid */}
      <div
        className="z-30 fixed w-full h-full pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle, var(--color-brown) 1.5px, transparent 1.5px)',
          backgroundSize: '39px 39px',
        }}
      />
    </div>
  )
}
